'use client';

import type { WrapUpPanelTone } from '../../wrap-up/wrap-up-style';

/**
 * The v9 pictures of the wrap-up steps, served from the app's public folder.
 * Each one is decorative: the step's title and text say everything it shows.
 */
export const WRAP_UP_PICTURES = {
  walking: '/signup/illustrations/walking.svg',
  rewardsPhone: '/signup/illustrations/rewards-phone.png',
  welcomeCall: '/signup/illustrations/welcome-call.png',
  callThumbnail: '/signup/illustrations/call-thumbnail.png',
  chatThumbnail: '/signup/illustrations/chat-thumbnail.png',
} as const;

export interface WrapUpPictureProps {
  tone: WrapUpPanelTone;
  size: 'illustration' | 'phone';
  src: string;
  'data-testid'?: string;
}

/** A decorative picture centred on its v9 panel. */
export function WrapUpPicture({ tone, size, src, 'data-testid': testId }: WrapUpPictureProps) {
  return (
    <div className="signup-wrap-up__panel" data-tone={tone} data-testid={testId}>
      <img src={src} alt="" data-size={size} />
    </div>
  );
}
